import { accountIssue } from './AccountIssueService';
import { changePassword } from './ChangePasswordService';
import { getListCountry } from './CountriesService';
import { createMember } from './CreateMemberService';
import { generateTokenSms } from './GenerateTokenSmsService';
import { getDependents } from './GetDependentsService';
import { getMember } from './GetMemberService';
import { getMaskedContact } from './MaskedContactService';
import { getMemberInfo } from './MemberInfoService';
import { getMemberStatus } from './MemberStatusService';
import { recoverBigDataQuestion } from './RecoverBigDataQuestionService';
import { recoverMemberNumber } from './RecoverMemberNumberService';
import { resetPasswordAccountIssue } from './ResetPasswordAccountIssueService';
import { resetPassword } from './ResetPasswordService';
import { uploadFileS3 } from './UploadFileS3Service';
import { updateMember } from './UpdateMemberService';
import { updateMemberSensitiveData } from './UpdateMemberSensitiveDataService';
import { validateBigDataQuestion } from './ValidateBigDataQuestionService';
import { validateDocument } from './ValidateDocumentService';
import { validateEmail } from './ValidateEmailRegisterService';
import { validateLegalGuardian } from './ValidateLegalGuardianService';
import { validateTokenEmail } from './ValidateTokenEmailService';
import { validateTokenSms } from './ValidateTokenSmsService';
import { getZipCode } from './ZipCodeService';
import { sendTokenEmail } from './SendTokenEmailService';
import { checkUpdateMemberStatus } from './CheckUpdateMemberStatusService';

export default {
  accountIssue,
  changePassword,
  createMember,
  generateTokenSms,
  getDependents,
  getListCountry,
  getMember,
  getMaskedContact,
  getMemberInfo,
  getMemberStatus,
  recoverBigDataQuestion,
  recoverMemberNumber,
  resetPasswordAccountIssue,
  resetPassword,
  uploadFileS3,
  updateMemberSensitiveData,
  updateMember,
  validateBigDataQuestion,
  validateDocument,
  validateEmail,
  validateLegalGuardian,
  validateTokenEmail,
  validateTokenSms,
  getZipCode,
  sendTokenEmail,
  checkUpdateMemberStatus,
};
